import React, { Fragment, useState, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Button from "../../../Button";
import makeAnimated from 'react-select/animated';
import styles from './StudentImport.module.sass'
import ClipLoader from 'react-spinners/ClipLoader';

const HeaderMatcher = ({ formData, school, headers }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [studentImport, setStudentImport] = useState({});

  const { register, handleSubmit, control } = useForm();
  const animatedComponents = makeAnimated();
  const csvHeaders = {
    student_id: 'Student ID',
    first_name: 'First Name',
    last_name: 'Last Name',
    grade: 'Grade',
    teacher: 'Teacher Name',
    email: 'Parent Email',
    phone: 'Phone',
    period: 'Period',
    mailing_address: 'Mailing Address',
    mailing_address2: 'Mailing Address 2',
    mailing_zip: 'ZIP Code',
    mailing_city: 'Mailing City',
    mailing_state: 'Mailing State',
    position: 'Position'
    // dob: 'Date of Birth',
    // access_code: 'Access Code'
  }

  const requiredFields = ['first_name', 'last_name', 'grade']

  const onSubmit = (data) => {
    setIsSubmitting(true);

    formData.append('headers', JSON.stringify(data));
    formData.append('school_id', school.value);

    fetch('/admin/student_imports',
      { method: 'POST', body: formData })
      .then(res => res.json())
      .then(json => {
        setStudentImport(json);

        if (!json.overwrite_warning && !json.teacher_missing_error) {
          handleContinue(false, json.id)
        }
      })
      .catch((error) => {
        toast('There was an error processing the CSV file. Please try again or use a different file.', { type: 'error' })
        setIsSubmitting(false)
      })
  }

  const handleContinue = (unenroll, id = undefined) => {
    setIsSubmitting(true)

    fetch(`/admin/student_imports/${id || studentImport.id}/import_csv?unenroll=${unenroll}`)
      .then(() => {
        window.location.href = `/admin/student_imports/${id || studentImport.id}`
      })
      .catch((error) => {
        toast('There was an error processing the CSV file. Please try again or use a different file.', { type: 'error' })
        setIsSubmitting(false)
      })
  }

  const renderHeaderOptions = () => (
    headers.map((header) => ({ label: header, value: header }))
  )

  const findDefaultValue = (key, value) => {
    const match = headers.find((header) => {
      return (
        header.includes(key) || key.includes(header) || header.includes(value) || value.includes(key)
      )
    })

    if (!match) return;

    return({ label: match, value: match })
  }

  const renderInputs = () => {
    const keys = Object.keys(csvHeaders);

    if (isSubmitting) {
      return (
        <div className={styles.loadingContainer}>
          <p>Importing student CSV for {school.label}. Please wait until you're redirected.</p>
          <ClipLoader color={'blue'} loading={true} size={150} />
        </div>
      )
    }

    return (
      keys.map((key, i) => {
        return (
          <label key={key}>
            {csvHeaders[key]}
            <Controller
              control={control}
              defaultValue={findDefaultValue(key, csvHeaders[key])}
              name={key}
              render={({ field: { onChange, value } }) => (
                <Select
                  {...register(key, { required: requiredFields.includes(key) })}
                  menuPlacement={i > 3 ? 'top' : 'bottom'}
                  onChange={({ value: newValue }) => onChange({ label: newValue, value: newValue })}
                  className="basic-single"
                  components={animatedComponents}
                  defaultValue={findDefaultValue(key, csvHeaders[key])}
                  options={renderHeaderOptions()}
                  name={key}
                />
              )}
            />
          </label>
        )
      })
    )
  }

  if (studentImport.teacher_missing_error) {
    return (
      <>
        <div className={styles.buttonContainer}>
          <a type="button" className={`btn btn-primary ${styles.btn}`} onClick={() => handleContinue(false)}>
            Continue anyway
          </a>
        </div>

        <p className={styles.warning}>
          {studentImport.teacher_missing_error}
        </p>
      </>
    )
  }

  if (studentImport.overwrite_warning) {
    return (
      <>
        <p className={styles.warning}>
          {studentImport.overwrite_warning}
        </p>

        <div className={styles.buttonContainer}>
          <a type="button" className={`btn btn-primary ${styles.btn}`} onClick={() => handleContinue(false)}>
            No, keep existing students and process this CSV
          </a>

          <a type="button" className={`btn btn-danger ${styles.btn}`} onClick={() => handleContinue(true)}>
            Yes, unenroll all students that are not present in this CSV
          </a>
        </div>
      </>
    )
  }


  return (
    <Fragment>
      {!isSubmitting && (
        <p className={styles.importInstructions}>
          Match headers to import students into {school.label}
        </p>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        {renderInputs()}

        {!isSubmitting && (
          <Button
            fullWidth
            classes={styles.button}
            variant='primary'
            disabled={isSubmitting}
          >
            Continue
          </Button>
        )}
      </form>
    </Fragment>
  )
}

export default HeaderMatcher;
